import React, { useEffect, useState } from "react";
import { Alert, AlertTitle, Container, CircularProgress, Grid } from "@mui/material";
import { getSsoLoginUrl } from "../../../services/LoginService";

const PKCE_CHARS = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-._~";

const getCodeVerifierStorageKey = (provider) => `${provider}_sso_code_verifier`;

const base64UrlEncode = (buffer) => {
  return btoa(String.fromCharCode(...new Uint8Array(buffer)))
    .replace(/\+/g, "-")
    .replace(/\//g, "_")
    .replace(/=+$/, "");
};

const generateCodeVerifier = () => {
  const verifierLength = 64;
  const maxValidByte = Math.floor(256 / PKCE_CHARS.length) * PKCE_CHARS.length;
  let codeVerifier = "";

  while (codeVerifier.length < verifierLength) {
    const randomValues = new Uint8Array(verifierLength);
    window.crypto.getRandomValues(randomValues);

    randomValues.forEach((value) => {
      if (value < maxValidByte && codeVerifier.length < verifierLength) {
        codeVerifier += PKCE_CHARS[value % PKCE_CHARS.length];
      }
    });
  }

  return codeVerifier;
};

const generateCodeChallenge = async (codeVerifier) => {
  const encodedVerifier = new TextEncoder().encode(codeVerifier);
  const digest = await window.crypto.subtle.digest("SHA-256", encodedVerifier);
  return base64UrlEncode(digest);
};

const SsoRedirect = ({ provider }) => {
  const [error, setError] = useState(false);

  useEffect(() => {
    const redirectToSso = async () => {
      try {
        const codeVerifier = generateCodeVerifier();
        const codeChallenge = await generateCodeChallenge(codeVerifier);
        const loginUrl = new URL(getSsoLoginUrl(provider), window.location.origin);

        sessionStorage.setItem(getCodeVerifierStorageKey(provider), codeVerifier);
        loginUrl.searchParams.set("code_challenge", codeChallenge);
        loginUrl.searchParams.set("code_challenge_method", "S256");

        window.location.assign(loginUrl.toString());
      } catch (err) {
        setError(true);
      }
    };

    redirectToSso();
  }, [provider]);

  return (
    <Container maxWidth="md">
      <div className="loginPageContainer">
        {error ? (
          <Alert severity="error">
            <AlertTitle>Sign in failed</AlertTitle>
            We were unable to start SSO sign in. Please try again.
          </Alert>
        ) : (
          <>
            <Grid container spacing={3}>
              <Grid item xs={12}>
                <div className="loginTitles">
                  <div className="title">Redirecting to Marriott</div>
                  <div className="subtitle">Please wait while we connect you securely.</div>
                </div>
              </Grid>
            </Grid>
            <CircularProgress size={28} className="loginProgress" />
          </>
        )}
      </div>
    </Container>
  );
};

export default SsoRedirect;
